import { render, staticRenderFns } from "./second_articleList.vue?vue&type=template&id=4968c2dc&scoped=true&"
import script from "./second_articleList.vue?vue&type=script&lang=js&"
export * from "./second_articleList.vue?vue&type=script&lang=js&"
import style0 from "./second_articleList.vue?vue&type=style&index=0&id=4968c2dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4968c2dc",
  null
  
)

export default component.exports